import React, {useContext, useEffect} from "react";
import {AuthContext} from "../Context/RootContext";
import {LanguageContext} from "../Context/LanguageContext";
import useProgress from "./useProgress";
import Constants from "../Configuration";
import {IPriceInfo} from "./usePayment";
import {ITogglePlugin} from "./useScripts";

export type IMainData = {
    email?: string;
    totalGamePlayed: number;
    subEnd: Date | null;
    isDiscordLinked: boolean;
    nextFreeSubscriptionAt?: string | null;
    isVkConfirmed: boolean;
    prices: IPriceInfo[];
    pluginToggleGetDtos: ITogglePlugin[];
    freeGames: IFreeGamesInfo | null;
}

export type IFreeGamesInfo = {
    remainingGames: number;
    maxGames: number;
    cooldown: number;
}

export enum LoadMainDataEnum {
    prices,
    main,
    plugins
}

const useMainData = () => {
    const state = React.useContext(AuthContext)
    const {error, isLoading, BeginLoading} = useProgress();

    const loadData = async (type: LoadMainDataEnum) => {
        return await BeginLoading(async () => {
            const data = await state.apiService.callApi(Constants.apiEndpoint +  `MainPage/${type}`);
            if (type === LoadMainDataEnum.main) {
                const freeGames = await state.apiService.callApi(Constants.apiEndpoint + 'MainPage/free-games');
                data.data.freeGames = freeGames.data;
            }
            return data.data;
        })
    }

    return {
        loadData
    }
}

export default useMainData

